<template>
  <div
    class="relative w-full h-full overflow-hidden"
    :style="{ backgroundImage: `url(${activeFile})` }"
  >
    <div class="h-full w-full flex items-center justify-center backdrop-blur">
      <video
        v-if="isVideo"
        :src="activeFile.src"
        title="Carousel video"
        controls
        class="h-full w-full object-contain bg-black"
      />
      <template v-else>
        <img
          :src="activeFile.src"
          alt="Carousel image"
          class="object-contain w-full h-full z-10"
        />
        <!-- <div
          class="absolute inset-0 w-full h-full z-0 bg-[black]"
          :style="
            backgroundVariant === SliderBackgroundVariant.BLUR
              ? `background-image: url(${activeFile.src}); filter: blur(10px); background-size: cover; background-position: center;`
              : ''
          "
        /> -->
      </template>
    </div>
    <IconButton
      v-if="enableNext"
      :icon-name="IconName.CHEVRON_RIGHT"
      label="View next image"
      :size="ButtonSize.XS"
      :variant="ButtonVariant.TEXT"
      :color="ButtonColor.SECONDARY"
      class="absolute carousel-control right-2 bg-white/70"
      @click="next"
    />
    <IconButton
      v-if="enablePrevious"
      :icon-name="IconName.CHEVRON_LEFT"
      label="View previous image"
      :size="ButtonSize.XS"
      :variant="ButtonVariant.TEXT"
      :color="ButtonColor.SECONDARY"
      class="absolute carousel-control left-2 bg-white/50"
      @click="previous"
    />
  </div>
</template>

<script setup lang="ts">
import { computed, ref, watch } from 'vue';
import {
  ButtonColor,
  ButtonSize,
  ButtonVariant,
  IconButton,
  IconName,
} from '@exfluential/ui';
import { isFileVideo } from '@/utils/file';
import { SliderBackgroundVariant } from '../../carousel.constants';

const emit = defineEmits<{
  'active-index-update': [index: number];
}>();

type Props = {
  files: { src: string; id: string }[];
  backgroundVariant: SliderBackgroundVariant;
};

const props = defineProps<Props>();

const activeIndex = ref(0);

const activeFile = computed(() => {
  return props.files[activeIndex.value];
});

const next = () => {
  activeIndex.value = Math.min(activeIndex.value + 1, props.files.length - 1);
};

const previous = () => {
  activeIndex.value = Math.max(activeIndex.value - 1, 0);
};

const enableNext = computed(() => {
  return activeIndex.value !== props.files.length - 1;
});

const enablePrevious = computed(() => {
  return activeIndex.value !== 0;
});

const isVideo = computed(() => {
  return isFileVideo(activeFile.value.src);
});

watch(activeIndex, () => emit('active-index-update', activeIndex.value));
</script>

<style scoped>
.carousel-control {
  top: calc(50% - 0.75rem);
}
</style>
